<template>
  <div>

    <!-- <pdv-thumbnail :pdvs="pdvdata"></pdv-thumbnail>
 -->
    <pdv-banner></pdv-banner>

    <div class="container mt-4">
      <div class="pdv-subtitles">
        {{ __('messages.help_you_organize') }}:
      </div>

      <div class="d-flex justify-content-between flex-wrap flex-sm-nowrap mt-2 ml-3 ml-sm-0">

        <div class="row">
          <div class="">
            <span class="icon-ui icon-pdv-flight m-0"></span>
          </div>
          <p class="col-8 m-0 ">
            <b>
              {{ __('messages.custom_guide') }}
            </b>
            <br>
            {{ __('messages.custom_guide_desc') }}

          </p>
        </div>
        <div class="row flex-nowrap ustify-content-center">
          <div class="">
            <span class="icon-ui icon-pdv-shop m-0"></span>
          </div>
          <p class="col-md-8 m-0 ">
            <b>
              {{ __('messages.easy_access_schedule') }}
            </b>
            <br>
            {{ __('messages.easy_access_schedule_desc') }}

          </p>

        </div>
        <div class="row justify-content-start justify-content-md-end">
          <div class="">
            <span class="icon-ui icon-pdv-shield m-0"></span>
          </div>
          <p class="col-8 m-0 ">
            <b>
              {{ __('messages.pay_easy') }}
            </b>
            <br>
            {{ __('messages.pay_easy_desc') }}
            <br>
            <a href="javascript:void(0)" @click="showModal()">
              {{ __('messages.know_paymethods') }}
            </a>
          </p>
        </div>
      </div>

      <div class="pdv-subtitles pdv-m-xxl">
        {{ __('messages.search_pdv') }}
      </div>

      <section id="section-pdv" class="row mb-4 mt-4 mr-0 ml-0">

        <pdv-list :dispatch="pdvdata.dispatch" :branches="pdvdata.branchs" :states="pdvdata.states"
          @selectPlace="setPlaceSelected($event)" :marker="elementMap" @changeState="onChangeState($event)"></pdv-list>

        <div class="col-12 col-sm-6 col-md-7 p-0" v-if="showHomeMap">
          <pdv-map :active="mapActivated" @selectMarker="setMarkerSelected($event)" :places="this.filteredList"
            :dispatch="pdvdata.dispatch" :selected="placeSelected"></pdv-map>
          <img v-if="!mapActivated" class="preview-map pointer" :src="`/assets/img/map-preview-pdv-${site}.png`"  :alt="__('messages.search_pdv')"
            @click="() => { mapActivated = true }">
        </div>
      </section >

    </div>
  </div>
</template>
    
<script>

import { PdvServices } from '../../services/PdvService';
const config = window.__pt.settings.site;
let pdvs = PdvServices.GetPlaces();

export default {
  props: {
    msg: String
  },
  data() {
    return {
      name: "Nombre",
      pdvdata: pdvs,
      placeSelected: null,
      modal: 'modal-payform',
      elementMap: null,
      filteredList: pdvs.branchs,
      showHomeMap: false,
      mapActivated: false,
      site: config.code.toLowerCase() 
    };
  },
  mounted() {
    if (window.screen.width > 576) {
      this.showHomeMap = true;
    }
  },
  methods: {
    setPlaceSelected(evt) {
      if (!this.mapActivated) {
        this.mapActivated = true;
        setTimeout(() => {
          this.placeSelected = evt;
        }, 1500);
      } else {
        this.placeSelected = evt;
      }
    },
    showModal() {
      $(`#${this.modal}`).modal("show");
    },
    setMarkerSelected(e) {
      this.elementMap = e;
    },
    onChangeState(e) {
      if (!this.mapActivated) {
        this.mapActivated = true;
        setTimeout(() => {
          this.filteredList = e;
        }, 1500);
      } else {
        this.filteredList = e;
      }
    }
  }
};
</script>
    
  
    